{
  "moreInformation": {
    "items": {
      "nextStepsProperty": {
        "title": "Vad är nästa steg om du ska köpa en bostad?",
        "paragraph1": "Här kan du läsa mer om hur du kan förbereda dig inför ditt bostadsköp och processen steg-för-steg.",
        "link": "Lär vår steg-för-steg guide"
      }
    }
  }
}
